var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 121.844,
    height: 122.844,
    viewBox: "0 0 121.844 122.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4443",
    "data-name": "Trazado 4443",
    d: "M88.219,0H33.624A33.8,33.8,0,0,0,0,33.9V88.943a33.8,33.8,0,0,0,33.624,33.9H88.219a33.8,33.8,0,0,0,33.625-33.9V33.9A33.8,33.8,0,0,0,88.219,0Zm22.815,88.943a22.934,22.934,0,0,1-22.815,23h-54.6a22.933,22.933,0,0,1-22.813-23V33.9a22.934,22.934,0,0,1,22.813-23H88.219a22.935,22.935,0,0,1,22.815,23V88.943Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4444",
    "data-name": "Trazado 4444",
    d: "M72.364,40.97c-17.312,0-31.4,14.308-31.4,31.9s14.084,31.895,31.4,31.895,31.4-14.308,31.4-31.895S89.676,40.97,72.364,40.97Zm0,52.807A20.915,20.915,0,1,1,92.95,72.865,20.774,20.774,0,0,1,72.364,93.777Z",
    transform: "translate(-11.442 -11.443)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4445",
    "data-name": "Trazado 4445",
    d: "M126.849,28.251a7.923,7.923,0,1,0,5.607,2.321A7.959,7.959,0,0,0,126.849,28.251Z",
    transform: "translate(-33.214 -7.698)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.21eb7013d13deedfc70d8a8cf401cfea.svg";
export { ForwardRef as ReactComponent };